<template>
  <div id="app">
    <div class="image-wrap">
      <img
        alt="DVC logo"
        src="https://dvc-eksaarde.be/wp-content/uploads/2018/03/dvc.png"
        class="dvc-logo"
      />
    </div>

    <p v-if="!formSubmitted">
      Gelieve hier uw gegevens in te vullen
    </p>

    <form
      @submit.prevent="sendRegistration"
      v-if="!formSubmitted"
      :class="formSubmittedClass"
    >
      <label for=""
        >Naam *
        <span class="input-wrap"
          ><input
            class="input"
            type="text"
            name="name"
            placeholder="eg. Jan Janssens"
            v-model="name"
            required/></span
      ></label>
      <label for=""
        >Aantal personen *
        <span class="input-wrap"
          ><input
            class="input"
            type="number"
            name="number"
            placeholder="eg. 4"
            min="1"
            step="1"
            v-model="number"
            required/></span
      ></label>
      <label for=""
        >E-mailadres *<span class="input-wrap"
          ><input
            class="input"
            type="email"
            name="mail"
            placeholder="eg. jan.janssens@hotmail.com"
            v-model="mail"
            required/></span
      ></label>
      <label for=""
        >Telefoonnummer *<span class="input-wrap"
          ><input
            class="input"
            type="tel"
            name="phone"
            placeholder="eg. 0478123456"
            v-model="phone"
            required/></span
      ></label>
      <label for=""
        >Anti spam: hoeveel is {{ number1 }} + {{ number2 }}? *<span
          class="input-wrap"
          ><input
            class="input"
            type="number"
            name="solution"
            v-model="solution"
            required/></span
      ></label>

      <div v-if="wrongAnswer">
        <p>
          Oeps, rekenfoutje gemaakt?
        </p>
      </div>

      <div>
        <p>
          Met het invullen van dit formulier ga je akkoord met de
          gegevensverwerking onder
          <a
            href="https://www.privacy-regulation.eu/nl/artikel-6-rechtmatigheid-van-de-verwerking-EU-AVG.htm"
            target="_blank"
            >artikel 6 GDPR, c)</a
          >
          en het relevante
          <a
            href="https://centredecrise.be/sites/default/files/mb_covid19_28072020.pdf"
            target="_blank"
            >Ministerieel Besluit</a
          >.<br /><br /><strong
            >Samen maken we het verschil<br />tegen COVID-19!</strong
          >
        </p>
      </div>

      <input
        class="submit"
        type="submit"
        :value="isLoading ? 'Laden ...' : 'Versturen'"
      />
    </form>

    <div v-else>
      <p>
        Formulier werd succesvol verstuurd. Uw gegevens worden
        <strong>binnen één maand</strong>
        verwijderd.
      </p>
      <p>
        Ga naar
        <a href="https://dvc-eksaarde.be/?utm_source=contact-tracing"
          >onze homepage</a
        >.
      </p>
    </div>

    <footer class="footer">
      <small
        >&copy; 2020
        <a
          href="https://dvc-eksaarde.be/?utm_source=contact-tracing"
          target="_blank"
          >DVC Eksaarde</a
        >
        -
        <a href="https://wiven.be?utm_source=dvc-registratie" target="_blank"
          >WiVen Web Solutions</a
        ></small
      >
    </footer>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "App",
  data: () => ({
    isLoading: false,
    formSubmitted: false,
    name: "",
    mail: "",
    phone: "",
    event: "",
    number: "",
    number1: 0,
    number2: 0,
    solution: "",
    wrongAnswer: false,
    formSubmittedClass: ""
  }),
  created() {
    let uri = window.location.href.split("?");
    if (uri.length == 2) {
      let vars = uri[1].split("&");
      let getVars = {};
      let tmp = "";
      vars.forEach(function(v) {
        tmp = v.split("=");
        if (tmp.length == 2) getVars[tmp[0]] = tmp[1];
      });
      this.event = getVars.event ? getVars.event : "";
      // do
    }
  },
  mounted() {
    this.number1 = Math.floor(Math.random() * 100) + 1;
    this.number2 = Math.floor(Math.random() * 50) + 1;
  },
  methods: {
    async sendRegistration() {
      this.formSubmittedClass = "form--submitted";

      if (!!this.name && !!this.mail && !!this.phone) {
        this.isLoading = true;

        if (parseInt(this.solution) !== this.number1 + this.number2) {
          this.wrongAnswer = true;
          return;
        }

        await axios
          .post(`${process.env.VUE_APP_API_BASE_URL}items/dvc_registraties`, {
            name: this.name,
            email: this.mail,
            phone: this.phone,
            event: this.event,
            number: this.number
          })
          .then(({ data }) => {
            if (data.public) {
              this.formSubmitted = true;

              this.name = "";
              this.mail = "";
              this.phone = "";
              this.number = "";
              this.wrongAnswer = false;

              setTimeout(() => {
                this.isLoading = false;
              }, 1000);
            }
          })
          .catch(error => {
            console.log(error);
          });
      }
    }
  }
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;700&display=swap");

body {
  color: #808080;
  font-family: "Open Sans", sans-serif;
}

#app {
  margin-bottom: 2rem;
}

.dvc-logo {
  margin: 1rem auto 3rem;
  display: block;
  width: 40vw;
  max-width: 200px;
}

.form--submitted {
  .input:valid {
    border: 1px solid green;
    outline: none;
  }

  .input:invalid {
    border: 1px solid red;
    outline: none;
  }
}

p {
  margin-bottom: 20px;
}

label {
  border: 0;
  outline: 0;
  font-size: 100%;
  background: transparent;
  margin: 0;
  padding: 0;
  display: block;
  margin-bottom: 20px;
}

.input-wrap {
  display: block;
  padding-right: 46px;
  margin-top: 7px;
}

.input {
  background-color: #f5f5f5;
  border-width: 0;
  color: #b5b5b5;
  padding: 16px 19px;
  width: 100%;
  font-size: 13px;
  border-radius: 0;
}

a {
  color: inherit;
}

.submit {
  font-family: "Open Sans", sans-serif;
  background-color: #aa4243;
  color: white;
  font-weight: bold;
  border-width: 0;
  padding: 0.75rem 1.5rem;
  letter-spacing: 0;
  text-transform: none;
  border-radius: 0;
  -webkit-appearance: none;
  margin: 2rem auto 0;
  text-align: center;
  display: block;
  font-size: 125%;
}

.footer {
  margin-top: 2rem;
  text-align: center;
}
</style>
